/**
 * Script JS para eliminar la etiqueta del botón de WhatsApp cuando está fuera de horario.
 * Utiliza MutationObserver para detectar inmediatamente cualquier inyección o re-inyección 
 * del elemento por parte del plugin, garantizando la persistencia de la eliminación.
 */

// Define el selector del elemento del botón. 
// Ajsuta esta variable si tu etiqueta es diferente a 'gty-whatsapp-chat-button'.
const SELECTOR_BOTON = 'gty-whatsapp-chat-button'; 
let botonGestionado = false; // Indica si ya encontramos y configuramos la lógica principal.

// -----------------------------------------------------
// 1. Lógica de Horario
// -----------------------------------------------------

/**
 * Determina si el botón DEBE estar visible (es decir, estamos en horario de atención).
 * @returns {boolean} True si debe estar visible, False en caso contrario.
 */
function debeEstarVisible() {
    const fechaActual = new Date();
    const diaSemana = fechaActual.getDay(); // 0=Domingo, 1=Lunes, ..., 6=Sábado
    const hora = fechaActual.getHours(); // 0-23

    // Lunes a Viernes (1-5): 9:00 a 17:59
    if (diaSemana >= 1 && diaSemana <= 5) {
        return hora >= 9 && hora < 18;
    } 
    // Sábado (6): 9:00 a 12:59
    else if (diaSemana === 6) {
        return hora >= 9 && hora < 13;
    } 
    // Domingo (0) y fuera de horario: Oculto
    return false;
}

// -----------------------------------------------------
// 2. Funciones de Acción
// -----------------------------------------------------

/**
 * Elimina o muestra el botón en base al horario.
 * @param {HTMLElement} botonElemento El elemento del botón de WhatsApp encontrado.
 */
function gestionarVisibilidadYEliminacion(botonElemento) {
    if (debeEstarVisible()) {
        // Horario de Atención: Nos aseguramos de que esté visible.
        // Si el plugin lo oculta, esta línea lo re-muestra con alta prioridad.
        botonElemento.style.setProperty('display', 'initial', 'important'); 
        console.log(`[WhatsApp Manager] Botón VISIBLE. En horario.`);
    } else {
        // Fuera de Horario: Eliminamos el elemento del DOM.
        if (botonElemento && botonElemento.parentNode) {
            botonElemento.remove(); 
            console.log(`[WhatsApp Manager] Botón ELIMINADO del DOM. Fuera de horario.`);
        }
    }
}

// ----------------------------------------------------------------------
// 3. MutationObserver (El vigilante eficiente)
// ----------------------------------------------------------------------

/**
 * Escucha cambios en el DOM y actúa inmediatamente cuando el botón aparece.
 * Esto reemplaza el uso de bucles de setTimeout/setInterval de alta frecuencia.
 */
const observer = new MutationObserver(function(mutations, obs) {
    const botonElemento = document.getElementsByTagName(SELECTOR_BOTON)[0];
    
    // Si el botón existe en el DOM:
    if (botonElemento) {
        
        // 1. Ejecutar la lógica de eliminación/visibilidad inmediatamente
        gestionarVisibilidadYEliminacion(botonElemento);

        // 2. Configurar la verificación de transición de hora solo una vez
        if (!botonGestionado) {
            console.log("[WhatsApp Manager] Primer elemento encontrado. Activando chequeo de horario.");
            botonGestionado = true;
            
            // Este intervalo de baja frecuencia solo maneja la transición de hora (ej: 17:59 a 18:00).
            // Lo ponemos cada hora (3,600,000 ms) ya que el Observer maneja el resto.
            setInterval(() => {
                const elementoActual = document.getElementsByTagName(SELECTOR_BOTON)[0];
                if (elementoActual) {
                    gestionarVisibilidadYEliminacion(elementoActual);
                }
            }, 3600000); 
        }
    }
});

// Iniciar el observer: Escucha cambios en el <body> y todos sus descendientes.
console.log("[WhatsApp Manager] Iniciando vigilancia del DOM...");
observer.observe(document.body, { 
    childList: true, // Monitorea si se añaden o eliminan nodos (importante para detectar la inyección del plugin)
    subtree: true    // Monitorea todos los descendientes del body
});

// NOTA: No necesitamos monitorear 'attributes' ('attributes: true') si nuestra acción es 'remove()'. 
// El monitoreo se enfoca en la aparición (childList) del elemento.